export const mainNum = 5

export const FIELD_REMOVE_SPACES = ['sku_barcode']
